import Blue from '~/core'

new Blue({
  name: 'Header Nav Menu',
  selector: '.header',
  setup(header) {
    const backdrop = header.querySelector('.header__backdrop')
    const mainContent = document.querySelector('#content')
    const util = header.querySelector('.header__util')
    // const utilPrimary = header.querySelector('.util__primary');
    const utilMenus = [...util.querySelectorAll('.util__primary-item--sub')]
    const nav = header.querySelector('.header__nav')
    const primaryItems = nav != null ? [...nav.querySelectorAll('.nav__primary-item')] : []
    const search = header.querySelector('.header__search')
    const searchToggle = search.querySelector('.search__toggle')
    const drawer = header.querySelector('.header__drawer')
    const primaryDrawerItems = drawer != null ? [...drawer.querySelectorAll('.nav__primary-item')] : []
    const drawerToggle = header.querySelector('.header__toggle')
    const drawerClose = header.querySelector('.drawer__close')
    const searchBox = search.querySelector('.search__input')
    const HPBox = search.querySelector('.hpkey')
    const searchButton = search.querySelector('.search__submit')
    const searchClose = search.querySelector('.search__close')
    const page = document.querySelector('.page')

    //   setInterval(function(){
    //     drawer.style.transition = "all 0.3s ease 0s";
    // }, 500);

    const headerIsActive = () => !![...header.querySelectorAll('.is-active, .is-open')].length

    const displayBackdrop = () => {
      backdrop.style.height = `${window.innerHeight - header.offsetHeight}px`

      if (headerIsActive()) {
        backdrop.classList.add('is-visible')
        mainContent.addEventListener('click', closeAllMenus)
        return
      }

      backdrop.classList.remove('is-visible')
    }

    const closeAllMenus = (e) => {
      if (e) {
        let inNav = e.target.closest('.header__nav')
        let inSearch = e.target.closest('.header__search')
        let inDrawer = e.target.closest('.header__drawer')
        if (inNav || inSearch || inDrawer) return
      }
      let activeMenus = [...header.querySelectorAll('.is-active, .is-open')]
      activeMenus.forEach((active) => active.classList.remove('is-active', 'is-open'))
      displayBackdrop()
    }

    const toggleDrawer = () => {
      let activeMenus = [...header.querySelectorAll('.is-active')]

      if (activeMenus.length) {
        activeMenus.forEach((active) => active.classList.remove('is-active'))
        displayBackdrop()
      }

      drawer.classList.toggle('is-open')
      if (!drawer.classList.contains('is-open')) {
        closeAllMenus()
      }
      displayBackdrop()
    }

    const bindNavEvents = (item, trigger, blurTrigger = false, clickOutside = false) => {
      if (trigger) {
        this.$addEvents(trigger, 'click.stop.prevent enter.stop.prevent space.stop.prevent', (e) => {
          if (clickOutside) {
            document.body.addEventListener('click', function detectClick(ev) {
              if (ev.target.closest(clickOutside) === null) {
                closeAllMenus()
                ev.currentTarget.removeEventListener(ev.type, detectClick)
              }
            })
          }
          search.classList.remove('is-active')
          util.classList.remove('is-active')
          nav.classList.remove('is-active')
          item.classList.toggle('is-active')

          if (!item.classList.contains('is-active')) {
            let activeChildren = [...item.querySelectorAll('.is-active')]
            activeChildren.forEach((i) => i.classList.remove('is-active'))
          } else {
            let menu = item.closest('ul')
            let activeSiblings = [...menu.querySelectorAll('.is-active')].filter((s) => s !== item)
            activeSiblings.forEach((sib) => sib.classList.remove('is-active'))

            if (!item.classList.contains('util__primary-item--sub')) {
              utilMenus.forEach((i) => i.classList.remove('is-active'))
              util.classList.add('is-active')
              nav.classList.add('is-active')
            } else {
              primaryItems.forEach((i) => i.classList.remove('is-active'))
              primaryDrawerItems.forEach((i) => i.classList.remove('is-active'))
              util.classList.remove('is-active')
              nav.classList.remove('is-active')
            }
          }
          displayBackdrop()
        })
      }

      if (blurTrigger) {
        this.$addEvents(blurTrigger, 'focusout.stop', () => {
          if (this.$screen.lg.matches) {
            if (!item.matches(':focus-within')) {
              item.classList.remove('is-active')
            }
          }
          closeAllMenus()
          displayBackdrop()
        })
        this.$addEvents(blurTrigger, 'escape.stop', () => {
          item.classList.remove('is-active')
          displayBackdrop()
        })
      }
    }

    const bindSearchEvents = () => {
      let inner = search.querySelectorAll('.search__inner')
      let input = search.querySelector('.search__input')
      this.$addEvents(searchToggle, 'click.stop.prevent enter.stop.prevent space.stop.prevent', () => {
        closeAllMenus(false)
        let activeMenus = [...nav.querySelectorAll('.is-active')]
        activeMenus.forEach((active) => active.classList.remove('is-active'))
        search.classList.toggle('is-active')
        displayBackdrop()
      })

      this.$addEvents(search, 'focusout.stop', () => {
        if (!search.matches(':focus-within') && !document.body.classList.contains('using-mouse')) {
          search.classList.remove('is-active')
        }
        displayBackdrop()
      })

      this.$addEvents(searchBox, 'keyup', (e) => {
        e.preventDefault()
        if (e.keyCode == 13) {
          doSearch()
        }
      })

      this.$addEvents(searchButton, 'click', (e) => {
        e.preventDefault()
        doSearch()
      })

      this.$addEvents(search, 'escape.stop', () => {
        search.classList.remove('is-active')
        displayBackdrop()
      })
      this.$addEvents(searchClose, 'click.stop.prevent enter.stop.prevent space.stop.prevent', () => {
        search.classList.toggle('is-active')
        displayBackdrop()
      })

      this.$addEvents(inner, 'transitionend.self.stop.prevent', (e) => {
        if (e.propertyName === 'visibility') {
          if (search.classList.contains('is-active')) {
            input.focus()
          }
        }
        displayBackdrop()
      })

      const doSearch = () => {
        let hpQuery = HPBox.value != '' ? `&hp=${HPBox.value}` : ''
        if (window.location.href.toLowerCase().includes('en-us')) {
          window.location.href = `/en-us/search?q=${searchBox.value}${hpQuery}`
        } else if (window.location.href.toLowerCase().includes('en-ca')) {
          window.location.href = `/en-ca/search?q=${searchBox.value}${hpQuery}`
        } else if (window.location.href.toLowerCase().includes('fr-ca')) {
          window.location.href = `/fr-ca/search?q=${searchBox.value}${hpQuery}`
        } else {
          window.location.href = `/search?q=${searchBox.value}${hpQuery}`
        }

        search.classList.toggle('is-active')
      }
    }

    const initMobile = () => {
      this.$addEvents(drawerToggle, 'click.stop.prevent enter.stop.prevent space.prevent', toggleDrawer)
      this.$addEvents(drawerClose, 'click.stop.prevent enter.stop.prevent space.prevent', () => {
        closeAllMenus(false)
      })
    }

    primaryItems.forEach((item) => {
      let trigger = item.querySelectorAll('.nav__primary-label, .nav__secondary-back')
      let blurTrigger = item.querySelector('.nav__secondary')
      bindNavEvents(item, trigger, blurTrigger)
    })
    primaryDrawerItems.forEach((item) => {
      let trigger = item.querySelectorAll('.nav__primary-label, .nav__secondary-back')
      let blurTrigger = item.querySelector('.nav__secondary')
      bindNavEvents(item, trigger, blurTrigger)
    })

    utilMenus.forEach((item) => {
      let trigger = item.querySelectorAll('.util__primary-label')
      let blurTrigger = item.querySelector('.util__secondary')
      bindNavEvents(item, trigger, blurTrigger, '.util__secondary')
    })

    bindSearchEvents()
    initMobile()

    this.$addEvents(document, 'click', closeAllMenus)
  },
})
